import React, { useEffect, useRef } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ExteriorSection from '../components/ExteriorSection';
import Features from '../components/Features';
import CommunityFeatures from '../components/CommunityFeatures';
import ApplicationProcess from '../components/ApplicationProcess';
import Gallery from '../components/Gallery';
import ContactForm from '../components/ContactForm';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';
import MobileContactBar from '../components/MobileContactBar';
import { useLanguage } from '../context/LanguageContext';

const LandingPage = () => {
  const { lang } = useLanguage();
  const hasTrackedView = useRef(false);

  useEffect(() => {
    if (window.fbq && !hasTrackedView.current) {
      window.fbq('track', 'ViewContent', {
        content_name: 'Townhouse for Rent',
        content_category: 'Residential Rental',
        value: 2800,
        currency: 'USD',
        language: lang
      });
      hasTrackedView.current = true;
    }
  }, [lang]);

  useEffect(() => {
    if (lang === 'es') {
      document.title = "Townhouse de Dos Pisos en Alquiler | $2,800 al Mes";
    } else {
      document.title = "Two-Story Townhouse for Rent | $2,800 per Month";
    }
  }, [lang]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
      <Navbar />
      
      <main className="flex-grow pt-16 pb-20 md:pb-0">
        <Hero />
        <ContactForm />
        <ExteriorSection />
        <Features />
        <Gallery />
        <CommunityFeatures />
        <ApplicationProcess />
        <FinalCTA />
      </main>

      <Footer />
      <MobileContactBar />
    </div>
  );
};

export default LandingPage;